import React from "react";
import { useSelector } from "react-redux";
import { getConfigurationState, getDuasState } from "../../Redux/GetState";
import "./Style.css";

export const Duas: React.FC = (): JSX.Element => {
  const { duas } = useSelector(getDuasState);
  const { configuration } = useSelector(getConfigurationState);

  const defaultDua = (): JSX.Element => {
    return (
      <div>
        <p className="duas-header">
          Reliance - Tawakkul <br />
          <br />
          رَبِّ إِنِّى لِمَآ أَنزَلْتَ إِلَىَّ مِنْ خَيْرٍ فَقِيرٌ
          <br />
          <br />
        </p>

        <p className="duas-body">
          Rabbi inni lima anzalta ilayya min khairin faqir
        </p>
        <br />
        <br />
        <p className="duas-body"></p>
      </div>
    );
  };

  const showTodayDua = (): JSX.Element => {
    const dateObj = new Date();
    const day = dateObj.getUTCDate();
    const todayDua = duas[day - 1];

    if (duas === undefined || duas.length === 0) return defaultDua();
    if (todayDua === undefined) return defaultDua();

    return (
      <div>
        <p className="duas-header">{todayDua.header}</p>
        <p className="duas-body">
          <br />
          {todayDua.body}
        </p>
        <p className="duas-footer">
          <br />
          {todayDua.footer}
        </p>
      </div>
    );
  };

  const showDataForSide2 = (): JSX.Element => {
    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: configuration.Slide3 }} />;
      </div>
    );
  };

  return (
    <div>
      <table className="duas-table-style">
        <tr>
          <td className="duas-table-td">
            {configuration.ShowDuas ? showTodayDua() : showDataForSide2()}
          </td>
        </tr>
      </table>
    </div>
  );
};
